import React from "react";
import { formatDate, formatInformationLength, getAssetTypeString } from "services/common";

const AssetCardInformation = ({ asset, maxLength, t }) => {
  if (!asset) return null;

  return (
    <div className="asset-information">
      <ul>
        {asset.resolution && (
          <li>
            <strong>{t("asset_resolution")}: </strong>
            {formatInformationLength(asset.resolution, maxLength)}
          </li>
        )}
        <li>
          <strong>{t("asset_type")}: </strong>
          {getAssetTypeString(asset.type)}
        </li>
        <li>
          <strong>{t("asset_createdAt")}: </strong>
          {formatDate(asset.createdAt)}
        </li>
        <li>
          <strong>{t("asset_updatedAt")}: </strong>
          {formatDate(asset.updatedAt)}
        </li>
      </ul>
    </div>
  );
};

export default AssetCardInformation;
